import { ReduxHelper } from "helpers";
import {
  IImportPeriodCycleCountByLocation,
  IImportPeriodCycleCountByProduct,
  IPeriodicCycleCountConfirmLocationRequest,
} from "model";

export const prefix = "CYCLE_COUNT";

export const importPeriodicCycleCountByProduct =
  ReduxHelper.generateActions<IImportPeriodCycleCountByProduct>(
    prefix,
    "IMPORT_PERIODIC_CYCLE_COUNT_BY_PRODUCT"
  );
export const importPeriodicCycleCountByLocation =
  ReduxHelper.generateActions<IImportPeriodCycleCountByLocation>(
    prefix,
    "IMPORT_PERIODIC_CYCLE_COUNT_BY_LOCATION"
  );

export const importPeriodicCycleCountConfirmLocation =
  ReduxHelper.generateActions<IPeriodicCycleCountConfirmLocationRequest>(
    prefix,
    "IMPORT_PERIODIC_CYCLE_COUNT_CONFIRM_LOCATION"
  );
